import { useEffect } from 'react';

/**
 * Custom hook to manage SEO meta tags dynamically for each page
 * Ensures proper canonical tags, og: tags, and page title
 */
export const useSEO = ({
  title = 'Empower Web - AI-Driven Digital Marketing & Web Development',
  description = 'AI-driven digital marketing agency in Delhi NCR. Expert SEO services, web development, business automation solutions to increase sales and grow your business.',
  canonical = 'https://empowerweb.in',
  ogTitle = '',
  ogDescription = '',
  ogImage = 'https://empowerweb.in/Empower.svg',
  keywords = ''
} = {}) => {
  useEffect(() => {
    // Set page title
    document.title = title;

    // Set or update description meta tag
    let metaDesc = document.querySelector("meta[name='description']");
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    // Set or update keywords meta tag
    if (keywords) {
      let metaKeywords = document.querySelector("meta[name='keywords']");
      if (!metaKeywords) {
        metaKeywords = document.createElement("meta");
        metaKeywords.name = "keywords";
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = keywords;
    }

    // Set canonical tag
    let canonical_tag = document.querySelector("link[rel='canonical']");
    if (!canonical_tag) {
      canonical_tag = document.createElement("link");
      canonical_tag.rel = "canonical";
      document.head.appendChild(canonical_tag);
    }
    canonical_tag.href = canonical;

    // Set OG tags
    const ogTags = [
      {
        property: 'og:title',
        content: ogTitle || title
      },
      {
        property: 'og:description',
        content: ogDescription || description
      },
      {
        property: 'og:url',
        content: canonical
      },
      {
        property: 'og:type',
        content: 'website'
      },
      {
        property: 'og:image',
        content: ogImage
      }
    ];

    ogTags.forEach((tag) => {
      let element = document.querySelector(`meta[property='${tag.property}']`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", tag.property);
        document.head.appendChild(element);
      }
      element.content = tag.content;
    });

    // Set robots meta tag
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "index, follow";

  }, [title, description, canonical, ogTitle, ogDescription, ogImage, keywords]);
};
